export async function openFullscreen(elem) {
  const isInFullScreen =
    (document.fullscreenElement && document.fullscreenElement !== null) ||
    (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
    (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
    (document.msFullscreenElement && document.msFullscreenElement !== null);

  if (isInFullScreen) {
    return;
  }

  if (elem.requestFullscreen) {
    await elem.requestFullscreen();
  } else if (elem.mozRequestFullScreen) {
    /* Firefox */
    await elem.mozRequestFullScreen();
  } else if (elem.webkitRequestFullscreen) {
    /* Chrome, Safari and Opera */
    await elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) {
    /* IE/Edge */
    await elem.msRequestFullscreen();
  }
}

export async function cancelFullscreen(elem) {
  if (elem.exitFullscreen) {
    await elem.exitFullscreen();
  } else if (elem.webkitExitFullscreen) {
    await elem.webkitExitFullscreen();
  } else if (elem.mozCancelFullScreen) {
    await elem.mozCancelFullScreen();
  } else if (elem.msExitFullscreen) {
    await elem.msExitFullscreen();
  }
}
